import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class EmployeeInviteAbility extends Ability {
  @service declare authz: AuthzService;

  get canSignIn(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.WORKPLACE_EMPLOYEE_INVITE_CREATE);
  }
}
